import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  selected?: boolean;
  onClick?: () => void;
  size?: "sm" | "md";
  tone?: "neutral" | "purple" | "yellow" | "blue" | "green" | "red";
};

const toneSelected: Record<NonNullable<Props["tone"]>, string> = {
  neutral: "bg-ink-900 text-white border-ink-900",
  purple: "bg-brand-purple text-white border-brand-purple",
  yellow: "bg-brand-yellow text-white border-brand-yellow",
  blue: "bg-brand-blue text-white border-brand-blue",
  green: "bg-brand-green text-white border-brand-green",
  red: "bg-brand-red text-white border-brand-red",
};

const toneUnselected: Record<NonNullable<Props["tone"]>, string> = {
  neutral: "bg-ink-50 text-ink-700 border-ink-200 hover:border-ink-300",
  purple: "bg-brand-purple-soft text-brand-purple border-transparent",
  yellow: "bg-brand-yellow-soft text-brand-yellow border-transparent",
  blue: "bg-brand-blue-soft text-brand-blue border-transparent",
  green: "bg-brand-green-soft text-brand-green border-transparent",
  red: "bg-brand-red-soft text-brand-red border-transparent",
};

const sizeCls: Record<NonNullable<Props["size"]>, string> = {
  sm: "h-8 px-3 text-[13px]",
  md: "h-10 px-4 text-[14px]",
};

export function Chip({ children, selected, onClick, size = "md", tone = "neutral" }: Props) {
  const interactive = !!onClick;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!interactive}
      className={`
        inline-flex items-center font-semibold border
        rounded-full transition-all duration-150 select-none
        ${interactive ? "cursor-pointer active:scale-[0.97]" : "cursor-default"}
        ${sizeCls[size]}
        ${selected ? toneSelected[tone] : toneUnselected[tone]}
      `}
    >
      {children}
    </button>
  );
}
